import type { CartGetData } from 'src/types/cart';

export const isBannedRetailer = (cart: CartGetData) => cart?.vendorStatus === 'banned';
